import AdapterMomentJalali from "@/shared/components/common/datePeacker";
import BoxKit from "@/shared/components/kit/box";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import {FormControl,FormControlLabel,Radio,RadioGroup,TextField,Typography,} from "@mui/material";
import moment from "jalali-moment";
import { SetStateAction } from "react";

type Props = {
  value: string;
  onChange: (newValue: string) => void;
  setFormValues: any;
  setOptionValue: React.Dispatch<SetStateAction<string>>;
};
/**
 * ContentFirstTab
 *
 * کامپوننتی برای انتخاب نوع چک (به نام خود یا ضامن) و وارد کردن مشخصات ضامن در صورت نیاز.
 * - رادیو باتن برای انتخاب "چک به نام خودم" یا "چک به نام فرد دیگر (ضامن)".
 * - در صورت انتخاب "other"، فیلدهای تاریخ تولد، کد ملی و شماره تلفن ضامن نمایش داده می‌شوند.
 * - مقادیر ورودی به `setFormValues` و `setOptionValue` منتقل می‌شوند.
 *
 * @param {Object} props
 * @param {string} props.value مقدار فعلی انتخاب شده در رادیو باتن
 * @param {(newValue: string) => void} props.onChange تابع برای تغییر مقدار رادیو باتن
 * @param {any} props.setFormValues تابع برای بروزرسانی فرم اصلی با داده‌های ورودی
 * @param {Dispatch<SetStateAction<string>>} props.setOptionValue تابع برای بروزرسانی مقدار گزینه انتخاب شده
 *
 * @component
 * @returns JSX.Element
 */

export const ContentFirstTab = ({value,onChange,setFormValues,setOptionValue,}: Props) => {
  const handleChangeDate = (date: any) => {
    const formatted = moment(date).format("jYYYY/jMM/jDD");
    setFormValues((prev: any) => ({...prev,birthday: formatted,}));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = e.target.value;
    onChange(selectedValue);
    setFormValues((prev: any) => ({...prev, guarantor_type: selectedValue === "myself" ? "myself" : "other",}));
    setOptionValue(selectedValue);
  };

  return (
    <FormControl component="fieldset" sx={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
      <TypoGraphyKit sx={{ color: "gray", mb: 2 }}>
        لطفا یکی از گزینه های زیر را انتخاب نمایید.
      </TypoGraphyKit>

      <RadioGroup value={value} onChange={handleRadioChange} sx={{ gap: 2 }}>
        <FormControlLabel value="myself" control={<Radio sx={{ color: "gray" }} disabled={true} />}
          label={
            <Typography sx={{ color: "gray" }}>
              چک صیادی به نام خودم می‌باشد.
            </Typography>
          }
        />
        <FormControlLabel value="other" control={<Radio sx={{ color: "gray" }} disabled={true}  />}
          label={
            <Typography sx={{ color: "gray" }}>
              چک صیادی به نام فرد دیگر (ضامن) می‌باشد.
            </Typography>
          }
        />
      </RadioGroup>

      {value === "other" && (
        <BoxKit sx={{ mt: 4, width: "100%" }}>
          <Typography sx={{ color: "white", mb: 2, textAlign: "right" }} variant="body1">
            لطفا مشخصات ضامن خود را وارد نمایید.
          </Typography>

          <BoxKit sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <AdapterMomentJalali handleChange={handleChangeDate} heightProps={"55px"}/>
            <TextField
              sx={{
                width: "30%",
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#1C1C1D",
                  "& input": {
                    color: "white",
                    "&::placeholder": {
                      color: "#666666",
                      opacity: 1,
                    },
                  },
                  "& fieldset": {
                    borderColor: "#666666",
                  },
                  "&:hover fieldset": {
                    borderColor: "#666666",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#666666",
                  },
                },
              }} name="NID" placeholder="کد ملی" onChange={handleInputChange} inputProps={{ maxLength: 10 }}
            />

            <TextField
              name="phoneNumber"
              placeholder="شماره تلفن همراه"
              sx={{
                width: "30%",
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#1C1C1D",
                  "& input": {
                    color: "white",
                    "&::placeholder": {
                      color: "#666666",
                      opacity: 1,
                    },
                  },
                  "& fieldset": {
                    borderColor: "#666666",
                  },
                  "&:hover fieldset": {
                    borderColor: "#666666",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#666666",
                  },
                },
              }}
              onChange={handleInputChange}
            />
          </BoxKit>
        </BoxKit>
      )}
    </FormControl>
  );
};

export default ContentFirstTab;
